// Module
var code = "<div id=\"V-D73933DE-7B9E-490D-A4E9-4995A53A0104\"> <div data-b-component=\"tab\" data-b-comp-items=\"{Binding gateways}\" data-b-comp-selecteditem=\"{Binding selectedGateway}\"> <div class=\"tabheader\"> <h6>{Binding title}</h6> </div> </div> </div>";
// Exports
export default code;